import React from "react";
import FieldInfoPopover from "./FieldInfoPopover";

export default function RadioField({ field, required, error, onChange }) {
  const items = field.dropdown || [];

  return (
    <div className="col-md-6">
      <label className={`text-blue mb-3 d-block ${error ? "text-danger" : ""}`}>
        {required ? <span>*</span> : null}
        {field.title}
      </label>
      <FieldInfoPopover html={field.labelInfoPopover} />
      <div className="row">
        {items.map((item) => (
          <div className="col-md-6" key={`${field.id}-${item.id}`}>
            <div className={`form-group input-radio ${error ? "is-invalid" : ""}`}>
              <input
                type="radio"
                name={field.id}
                id={`${field.id}-${item.id}`}
                value={item.value}
                checked={(field.value || "") === item.value}
                onChange={(event) => onChange(field.id, event.target.value)}
              />
              <label htmlFor={`${field.id}-${item.id}`}>{item.text || item.value}</label>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
